import React from 'react';
import * as queryString from 'qs';

const BackToOriginalDocumentLink = () => {
  const queryParams = queryString.parse(window.location.search, { ignoreQueryPrefix: true });
  const { backToOriginalDocument } = queryParams;

  if (backToOriginalDocument) {
    const backToOriginalURLDecoded = decodeURIComponent(backToOriginalDocument);
    const onClick = () => {
      window._track('Back to Original Document', 'Template Builder');
      window.location.assign(backToOriginalURLDecoded);
    };

    return (
      <div
        className="back-to-original-document-wrapper"
        onClick={onClick}
      >
        <div
          className="back-to-original-document-link"
        >
          BACK TO ORIGINAL DOCUMENT
        </div>
      </div>
    );
  }
  return null;
};

export default BackToOriginalDocumentLink;



// WEBPACK FOOTER //
// ./src-react/SelfServeBuilder/SelfServeBuilderToolbar/BackToOriginalDocumentLink.jsx